import { CommunicationKind } from './domain.models';

export interface CommunicationTemplate {
  key: string;
  label: string;
  kind: CommunicationKind;
  subject: string;
  body: string;
}

/** Illustrative templates (spec P-79). Placeholders: {cliente}, {productor}. */
export const COMMUNICATION_TEMPLATES: CommunicationTemplate[] = [
  {
    key: 'installment-due', label: 'Aviso de vencimiento de cuota', kind: 'transactional',
    subject: 'Aviso: cuota pendiente de pago',
    body: 'Hola {cliente}, te escribo para avisarte que tenés una cuota pendiente de pago en tu seguro. '
      + 'Si ya la abonaste, desestimá este mensaje; si no, avisame y te ayudo a regularizarla.\n\nSaludos,\n{productor}',
  },
  {
    key: 'renewal', label: 'Aviso de renovación', kind: 'transactional',
    subject: 'Tu seguro está por renovar',
    body: 'Hola {cliente}, tu póliza está próxima a vencer. Ya estoy consultando al mercado para ofrecerte las mejores '
      + 'opciones de renovación. Te contacto en los próximos días.\n\nSaludos,\n{productor}',
  },
  {
    key: 'documents-send', label: 'Envío de documentación', kind: 'transactional',
    subject: 'Documentación de tu seguro',
    body: 'Hola {cliente}, te envío la documentación de tu seguro. Cualquier duda, escribime.\n\nSaludos,\n{productor}',
  },
  {
    key: 'documents-request', label: 'Pedido de documentación', kind: 'transactional',
    subject: 'Necesito documentación para avanzar',
    body: 'Hola {cliente}, para avanzar con tu trámite necesito que me envíes la documentación pendiente. '
      + 'Podés responder este mail con los archivos adjuntos.\n\nSaludos,\n{productor}',
  },
  {
    key: 'birthday', label: 'Saludo de cumpleaños', kind: 'commercial',
    subject: '¡Feliz cumpleaños!',
    body: '¡Feliz cumpleaños, {cliente}! Te deseo un gran día.\n\nUn abrazo,\n{productor}',
  },
];

export function templateByKey(key: string): CommunicationTemplate | undefined {
  return COMMUNICATION_TEMPLATES.find(t => t.key === key);
}

export function fillTemplate(text: string, clientName: string, producerName: string): string {
  return text.replaceAll('{cliente}', clientName).replaceAll('{productor}', producerName);
}
